import { Box } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import {
  LegacyFAIcon,
  LegacyFAIcons,
  LegacyFASize,
} from '~/legacy-components/LegacyFAIcon';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';

import { DevPlan } from '../data/index';

import { useSxStyles } from './useStyles';

type PropsType = {
  plansData?: DevPlan;
};

export const DevelopmentActivities = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { plansData } = props;

  const getStatusIcon = (strFaceId: string) => {
    switch (strFaceId) {
      case '1':
        return (
          <LegacyFAIcon
            sx={sxStyles.smile}
            FAIcon={LegacyFAIcons.Smile}
            FASize={LegacyFASize.X2}
          />
        );
      case '2':
        return (
          <LegacyFAIcon
            sx={sxStyles.meh}
            FAIcon={LegacyFAIcons.Meh}
            FASize={LegacyFASize.X2}
          />
        );
      case '3':
        return (
          <LegacyFAIcon
            sx={sxStyles.frown}
            FAIcon={LegacyFAIcons.Frown}
            FASize={LegacyFASize.X2}
          />
        );
      default:
        return '';
    }
  };

  return (
    <Box component="table" sx={sxStyles.table}>
      <caption>
        <LegacyHeadingWithActions
          headingIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Table} />}
          heading={t('laDevActivities')}
        />
      </caption>
      <thead>
        <tr>
          <Box component="th" sx={sxStyles.thEmoji}></Box>
          <Box component="th" sx={sxStyles.thDevArea}>
            {t('laDevArea')}
          </Box>
          <Box component="th" sx={sxStyles.thDevAction}>
            {t('laDevAction')}
          </Box>
          <Box component="th" sx={sxStyles.thMethod}>
            {t('laMethod')}
          </Box>
          <Box component="th" sx={sxStyles.thGoal}>
            {t('laGoal')}
          </Box>
          <Box component="th" sx={sxStyles.thEndDate}>
            {t('laEndDate')}
          </Box>
          <Box component="th" sx={sxStyles.thInfo}>
            {t('laInfo')}
          </Box>
        </tr>
      </thead>
      <tbody>
        {plansData?.devPlanActivities.map((data, index) => {
          return (
            <tr key={index}>
              <Box component="td">{getStatusIcon(data.fDevPlanActStatus)}</Box>
              <Box component="td" sx={sxStyles.td}>
                {data.fDevPlanActDevArea}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {data.fDevPlanActDevAction}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {data.fDevPlanActDevMethod}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {data.fDevPlanActDevGoal}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {data.fDevPlanActEndDate
                  ? moment(data.fDevPlanActEndDate).format('YYYY-MM-DD')
                  : ''}
              </Box>
              <Box component="td" sx={sxStyles.td}>
                {data.fDevPlanActInfo}
              </Box>
            </tr>
          );
        })}
      </tbody>
    </Box>
  );
};
